import { useModals } from '@/components/modals/ModalProvider';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { SiteReport } from '@/libs/fleet-api/services/types';
import { Col, Divider, Form, Input, Row } from 'antd';
import { FC } from 'react';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

export const useFBDHSiteVisitReportDetailForm = () => {
	return useForm<SiteReport<'payload'>>();
};

const FBDHSiteVisitReportDetail: FC = () => {
	const { form, value, fieldName } = useFBDHSiteVisitReportDetailForm();
	const { openMapModal } = useModals();
	const { siteReport, surveyInformation } = useFBDHVisitReportApprovalPage();

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			name="siteReport"
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					visitPurpose: siteReport?.visitPurpose,
					visitSiteAddress: siteReport?.visitSiteAddress,
					visitSiteLat: siteReport?.visitSiteLat,
					visitSiteLong: siteReport?.visitSiteLong,
					visitLocationAnalysis: siteReport?.visitLocationAnalysis,
					additionalVisitInfo: siteReport?.additionalVisitInfo,
					actionPlan: siteReport?.actionPlan,
				} as SiteReport<'payload'>
			}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('visitPurpose')}
				label="Tujuan Kunjungan"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				label="Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
			>
				<Form.Item
					name={fieldName('visitSiteAddress')}
					noStyle
				/>
				<Form.Item
					name={fieldName('visitSiteLat')}
					noStyle
				/>
				<Form.Item
					name={fieldName('visitSiteLong')}
					noStyle
				/>
				<Row
					gutter={10}
					align="middle"
				>
					<Col flex="auto">
						<a
							href="#"
							onClick={() => {
								openMapModal({
									title: 'Lokasi Kunjungan',
									address: value?.visitSiteAddress,
									latitude: value?.visitSiteLat,
									longitude: value?.visitSiteLong,
									viewOnly: true,
									// onChange: ({ address, center }) => {
									// 	form.setFieldsValue({
									// 		visitSiteAddress: address,
									// 		visitSiteLat: center.lat,
									// 		visitSiteLong: center.lng,
									// 	});
									// },
								});
							}}
						>
							<u>{value?.visitSiteAddress}</u>
						</a>
					</Col>
				</Row>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('visitLocationAnalysis')}
				label="Analisa Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalVisitInfo')}
				label="Informasi Lainnya"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
		</Form>
	);
};

export default FBDHSiteVisitReportDetail;
